import React from "react";

export default function StepIdentity({ data, errors = {}, onChange, onNext }) {
  return (
    <div className="add-form">
      {/* Legal name (required) */}
      <label>
        <span className="lbl">Legal name</span>
        <input
          value={data.legal_name || ""}
          onChange={(e) => onChange({ legal_name: e.target.value })}
          className={errors.legal_name ? "invalid" : ""}
          aria-invalid={!!errors.legal_name}
          required
        />
        {errors.legal_name && <small className="error">{errors.legal_name}</small>}
      </label>

      {/* Trading name (optional) */}
      <label>
        <span className="lbl">Trading name (optional)</span>
        <input
          value={data.trading_name || ""}
          onChange={(e) => onChange({ trading_name: e.target.value })}
        />
      </label>

      {/* Entity type (required) */}
      <label>
        <span className="lbl">Entity type</span>
        <select
          value={data.entity_type || "sole_trader"}
          onChange={(e) => onChange({ entity_type: e.target.value })}
          className={errors.entity_type ? "invalid" : ""}
          aria-invalid={!!errors.entity_type}
        >
          <option value="sole_trader">Sole trader</option>
          <option value="ltd">Limited company</option>
          <option value="partnership">Partnership</option>
        </select>
        {errors.entity_type && <small className="error">{errors.entity_type}</small>}
      </label>

      {/* DOB (required) */}
      <label>
        <span className="lbl">Date of birth</span>
        <input
          type="date"
          value={data.dob || ""}
          onChange={(e) => onChange({ dob: e.target.value })}
          className={errors.dob ? "invalid" : ""}
          aria-invalid={!!errors.dob}
        />
        {errors.dob && <small className="error">{errors.dob}</small>}
      </label>

      <div className="actions">
        <button className="btn" onClick={onNext}>Next</button>
      </div>
    </div>
  );
}

